/**
 * The "Pedal listed successfully!" banner hides itself after 5 seconds. Since
 * 2026-10-07 a new listing can also open the native "turn on notifications"
 * pop-up, which covers the banner. This keeps the two independent:
 *
 * - The banner timer is armed immediately, exactly as before. If no pop-up
 *   opens (web, already granted, snoozed, check failed, prompt errored), it
 *   is never touched again.
 * - Only when the pop-up ACTUALLY opened for this listing (the prompt
 *   resolves { opened: true, closed }) is the timer cleared, then re-armed
 *   for a full 5 seconds once the pop-up closes.
 * - If something else re-armed the timer in the meantime (a newer
 *   submission), this listing's pop-up leaves it alone.
 * - Never throws; a prompt failure can't affect the listing's success.
 *
 * @param {Promise<{opened: boolean, closed?: Promise}>|null} prompt
 * @param {{ current: any }} timerRef   holds the current banner timer
 * @param {() => any} arm               starts a 5 s timer, returns its handle
 * @param {(t: any) => void} clear
 */
export function armBannerAroundPrompt(prompt, timerRef, arm, clear) {
  if (timerRef.current) clear(timerRef.current);
  timerRef.current = arm();
  if (!prompt) return;
  const armedForThisListing = timerRef.current;
  Promise.resolve(prompt)
    .then((r) => {
      if (!r || r.opened !== true) return;
      if (timerRef.current !== armedForThisListing) return;
      clear(armedForThisListing);
      timerRef.current = null;
      return Promise.resolve(r.closed).then(() => {
        if (timerRef.current === null) timerRef.current = arm();
      });
    })
    .catch(() => {});
}
